<template>
    <div class="mainpage">
        <div class="input-fields">
            <label class="mb-1" for="static-url">Webhook endpoint</label>
            <InputText @keyup="check" type="text" v-model="endpoint" placeholder="enter url here" />
            <span  v-if="errorMessage" class="validation-error">{{ errorMessage }}</span>
        </div>
        <KeyValueCollector divClass="mb-2" label="Header" :value="headerData" @updatePair="updateKeyValue($event)"/>
        <div class="actions-btns">
            <div class="gap">
                <Button class="mr-3" :disabled="this.isDisabled" label="Update" @click="updateSettings"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import KeyValueCollector from '@/components/common/KeyValueCollector.vue'

export default {
    name: 'Webhooks',
    components: {
        KeyValueCollector
    },
    data () {
        return {
            errorMessage: ''
        }
    },
    methods: {
        async updateKeyValue (val) {
            this.headerData = val
        },
        async updateSettings () {
            const headerObject = this.headerData.reduce((obj, [key, value]) => {
                if (key !== '') {
                    obj[key] = value
                }
                return obj
            }, {})
            if (!this.endpoint) {
                this.errorMessage = 'Please enter endpoint'
                return
            }
            const data = {
                endpoint: this.endpoint,
                headers: headerObject
            }
            this.globalLoader = true
            await this.$store.dispatch('Webhooks/Webhook/updateWebhook', data)
            this.globalLoader = false
        },
        check () {
            if (this.endpoint) {
                this.errorMessage = ''
            } else {
                this.errorMessage = 'Please enter endpoint'
            }
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapModels('Webhooks/Webhook', ['endpoint', 'headerData', 'beforeHeaderData', 'beforeEndpoint']),
        ...mapGetters({ currentUser: 'currentUser' }),
        isDisabled () {
            let equalKV = true
            let headerLength = 0
            for (const element of this.headerData) {
                if (element[0]) {
                    headerLength++
                    if (this.beforeHeaderData[element[0]] !== element[1]) {
                        equalKV = false
                        break
                    }
                }
                equalKV = true
            }
            if (headerLength !== Object.keys(this.beforeHeaderData).length) {
                equalKV = false
            }
            if (equalKV && this.endpoint === this.beforeEndpoint) {
                return true
            }
            return false
        }
    },
    async mounted () {
        await this.$store.dispatch('Webhooks/Webhook/fetchWebhook')
    }
}
</script>

<style>

</style>
